import React, { Component } from 'react';
import { connect } from 'react-redux';
import VideoPlayer from '../../../../Shared/VideoPlayer/VideoPlayer';
import { setSceneVideo } from '../../../../../redux/actions';
import BackButton from '../../../../Shared/BackButton/BackButton';
import { trackEvent } from '../../../../../utils/Stats';
import './SceneVideo.css';

class SceneVideo extends Component {
  constructor(props) {
    super(props);

    this.handleClick = this.handleClick.bind(this);
    this.handleEnd = this.handleEnd.bind(this);
  }

  handleClick() {
    this.props.setSceneVideo('');
    trackEvent('btn', 'close-scene-video');
  }
  handleEnd() {
    this.props.setSceneVideo('');
  }

  render() {
    const { type, active, source } = this.props;
    return (
      <div className={`scene-video ${type} ${active ? 'active' : ''}`}>
        {active && (
          <VideoPlayer
            source={source}
            onEnded={this.handleEnd}
            disablePointer
          />
        )}
        <BackButton onClick={this.handleClick} />
      </div>
    );
  }
}

const mapDispatchToProps = dispatch => ({
  setSceneVideo: videoId => dispatch(setSceneVideo(videoId)),
});

export default connect(null, mapDispatchToProps)(SceneVideo);



// WEBPACK FOOTER //
// ./src/components/App/Dukla/Scene/SceneVideo/SceneVideo.js